import { Grow, Paper } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import useLayout from '../../../hooks/layout/use-layout';

interface AssistantPanelProps {
  open: boolean;
  /** Docked, it is a bar at the right side, as tall as the screen, and no longer floats over the page. */
  docked: boolean;
  children: ReactNode;
}

/** The chat window of larger screens: it floats at a corner, growing out of the button, or is docked at the side. */
export default function AssistantPanel({
  open,
  docked,
  children,
}: AssistantPanelProps) {
  const { t } = useTranslation();
  const { dockWidth, assistantCornerOffset, assistantZIndex } = useLayout();

  return (
    <Grow
      in={open}
      mountOnEnter
      unmountOnExit
      style={{ transformOrigin: 'bottom right' }}
    >
      <Paper
        elevation={docked ? 0 : 12}
        role="dialog"
        aria-label={t('ASSISTANT_TITLE')}
        sx={
          docked
            ? {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                width: dockWidth,
                display: 'flex',
                flexDirection: 'column',
                zIndex: assistantZIndex,
                overflow: 'hidden',
                borderRadius: 0,
                borderLeft: 1,
                borderColor: 'divider',
              }
            : {
                position: 'fixed',
                right: assistantCornerOffset,
                bottom: assistantCornerOffset,
                width: 380,
                height: 'clamp(520px, 78vh, 820px)',
                maxHeight: '85vh',
                display: 'flex',
                flexDirection: 'column',
                zIndex: assistantZIndex,
                overflow: 'hidden',
                borderRadius: 1,
              }
        }
      >
        {children}
      </Paper>
    </Grow>
  );
}
